<template>
    <v-progress-linear indeterminate></v-progress-linear>
</template>

<script>
  export default {

  };
</script>
